/**
 * Chatwoot chat utility functions
 */

declare global {
  interface Window {
    $chatwoot?: {
      toggle: (state?: 'open' | 'close') => void;
      toggleBubbleVisibility: (state: 'hide' | 'show') => void;
      setUser: (id: string, info: Record<string, any>) => void;
      reset: () => void;
    };
  }
}

export function isChatwootAvailable(): boolean {
  return typeof window !== 'undefined' &&
    window.$chatwoot !== undefined &&
    typeof window.$chatwoot.toggle === 'function';
}

export function openChat(_message?: string): void {
  if (isChatwootAvailable()) {
    window.$chatwoot!.toggle('open');
  }
}

export function hideChat(): void {
  if (isChatwootAvailable()) {
    window.$chatwoot!.toggle('close');
  }
}
